module.exports = __webpack_public_path__ + "static/apple-icon-180x180-4c4866a676b8f5e3014bd1f04c03d2ee.png";